const makeStateRouter = require('abstract-state-router')
const makeRactiveRenderer = require('ractive-state-router')

const ractiveRenderer = makeRactiveRenderer(Ractive, {
	data: {
		toLocaleDateString(dateString) {
			if (dateString === null || dateString === undefined) {
				return ''
			} //otherwise, toLocaleDateString will return the start of unix time
			dateString = dateString.length === 10 ? `${dateString }T23:59:59Z` : dateString//mad hax bro
			return new Date(dateString).toLocaleDateString()
		},
		stringToBoolean: str => {
			return stringToBoolean(str)
		},
		booleanToString: bool => {
			return booleanToString(bool)
		},
	},
})

const stateRouter = makeStateRouter(ractiveRenderer, 'body')

const makeItSelect = require('@isoftdata/select')
const makeItInput = require('@isoftdata/input')
const makeItButton = require('@isoftdata/button')
const makeItCheckbox = require('@isoftdata/checkbox')
const makeItCurrencyInput = require('@isoftdata/currency-input')
const makeItTable = require('@isoftdata/table')
const makeItTextArea = require('@isoftdata/textarea')
const makeItModal = require('@isoftdata/modal')
const makeItAddressCard = require('@isoftdata/address-card')
const financialNumber = require('financial-number')
const camelize = require('camelize')
const makeItTableCardFooter = require('@isoftdata/table-card-footer')
const format = require('date-fns/format')
const addBusinessDays = require('date-fns/addBusinessDays')
const { freightClass } = require('./fpg/enums')
const currency = require('@isoftdata/utility-currency')
const pluralIfNeeded = require('@isoftdata/utility-string').pluralIfNeeded
const { replaceObjectOrConcat } = require('@isoftdata/utility-array')
const addDays = require('date-fns/addDays')
const parseISO = require('date-fns/parseISO')
const parse = require('date-fns/parse')
const isToday = require('date-fns/isToday')
const dateDiff = require('date-fns/differenceInCalendarDays')

const countries = [
	{ code: 'USA', name: 'United States of America' },
	{ code: 'CANADA', name: 'Canada' },
	{ code: 'MEXICO', name: 'Mexico' },
]

const dlsNoResponse = 'No DLS response given. This could be an incorrect address, but the only way to know for sure is to contact DLS at 1-866-940-6321 for help.'

stateRouter.addState({
		name: 'app',
		template: {
			template: require('./app.html'),
			data: {
				currencyFormat: currency.format,
				pluralIfNeeded,
				selectedShipperAccessorials: [],
				selectedCosigneeAccessorials: [],
				fpgQuoteSent: false, // Set to false so Get Rates button is shown
				freightClass, // FPG Freight Class TODO switch to GET instead of v2 static list
				// integrationList: [
				// 	'FPG', 'TForce'
				// ],
				// quoteColumns: [
				// 	{ property: 'service', name: 'Service' },
				// 	{ property: 'carrierName', name: 'Carrier' },
				// 	{ property: 'transitTime', name: 'Transit Time (Days)' },
				// 	{ property: 'markedUpTotal', name: 'Price', defaultSortColumn: true, defaultSortDirection: 'ASC' },
				// ],
			},
			transitions: {
				slide: require('ractive-transitions-slide'),
			},
			components: {
				itSelectTwo: makeItSelect({ twoway: true, lazy: false }),
				itInputTwo: makeItInput({ twoway: true, lazy: false }),
				itTextAreaTwo: makeItTextArea({ twoway: true, lazy: false }),
				itButton: makeItButton(),
				itTable: makeItTable(),
				itModal: makeItModal(),
				itAddressCard: makeItAddressCard({ lazy: true }),
				itCheckbox: makeItCheckbox(),
				itCurrencyInput: makeItCurrencyInput({ twoway: true }),
				itTableCardFooter: makeItTableCardFooter(),

			},
			decorators: {
				  inputValidate: require('@isoftdata/ractive-decorator-valid'),
			},
			computed: {
				displaySaleLines() {
					const salesOrderLines = this.get('salesOrder.salesOrderLines')
					if (salesOrderLines) {
						return salesOrderLines
							.filter(line => line.type === 'Inventory' || line.type === 'Misc')
							.filter(line => line.quantity > 0)
							.map(line => {
								const total = financialNumber(line.quantity.toString())
									.times(line.price.toString())
									.changePrecision(2)
									.toString()
								return { ...line, total, toMove: false, dimensions: {}, class: {} }
							})
					}
					return []
				},
				setIntegration() {
					const integration = this.get('postData.shippingSource')
					if (!integration) {
						return 'TForce'
					}
					return integration
				},
				// Workaround for recalculating price markup on FPG response
				markUpFpgPrice() {
					const price = this.get('bookedShipment.awardedQuotePricing.customer')
					if (!price) {
						return 0
					} else {
						const markupMultiplier = this.get('markupMultiplier')
						const markedUpTotal = financialNumber(markupMultiplier)
						.times(price)
						.changePrecision(2)
						.toString()
	
					return markedUpTotal
					}
				},
	/*
		Set disabled, hidden and/or required fields
	*/
				additionalDetailsHidden() {
					// Hide the Additional Details card
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						return true
					}
				},
				// addShipperAccessorialDisabled() {
				// 	const integration = this.get('setIntegration')
				// 	if (integration === 'TForce') {
				// 		return true
				// 	}
				// },
				bookShipmentDisabled() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return this.get('postData.scheduleShipmentPermission') === 'True' && this.get('postData.quoteOnlyMode') === 'False'
					}
					if (integration === 'TForce') {
						return this.get('postData.scheduleShipmentPermission') === 'True' && this.get('postData.quoteOnlyMode') === 'False'
					}
				},
				containerClassHidden() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
					if (integration === 'TForce') {
						return false
					}
				},
				containerCommodityHidden() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
					if (integration === 'TForce') {
						return false
					}
				},
				containerDimensionsRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return false
					}
					if (integration === 'TForce') {
						return true
					}
				},
				containerWeightRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
					if (integration === 'TForce') {
						return true
					}
				},
				containerTypeRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
					if (integration === 'TForce') {
						return true
					}
				},
				deliveryDateRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
				},
				deliveryDetailsDisabled() {
					// Hide the Delivery Details card
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						return true
					}
				},
				dispatchDisabled() {
					// FPG can test book w/o dispatch or p/u request
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						const enableDispatch = this.get('enableDispatch')
						const testingMode = this.get('postData.testingMode')
						// If dispatch is disabled and in testing mode
						if (!enableDispatch && testingMode === 'True') {
							return true // Disable dispatch
						}
						return false
					}
				},
				equipmentTypeDisabled() {
					// Tforce doesn't have equipment type option
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						return true
					}
				},
				equipmentTypeRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
					if (integration === 'TForce') {
						return false
					}
				},
				getRatesDisabled() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return !this.canGetFpgRates()
					}
					if (integration === 'TForce') {
						return !this.canGetTforceRates()
					}
				},
				moveProductButtonDisabled() {
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						// TForce doesn't appear to support multiple ship containers
						return true
					}
				},
				payTypeRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
					if (integration === 'TForce') {
						return false
					}
				},
				// Disable left button if pickup date is today
				pickupDateLeftDisabled() {
					const integration = this.get('setIntegration')
					let pickupValue = this.get('pickupDate')
					if (integration === 'FPG') {
						if (typeof pickupValue === 'string') {
							pickupValue = parse(pickupValue, 'MM-dd-yyyy', new Date())
						}
						if (isToday(pickupValue)) {
							return true
						}
					}
					if (integration === 'TForce') {
						if (typeof pickupValue === 'string') {
							pickupValue = parse(pickupValue, 'MM-dd-yyyy', new Date())
						}
						if (isToday(pickupValue)) {
							return true
						}
					}
				},
				// Disable left button if delivery date is less than or equal to pickup date +1
				deliverDateLeftDisabled() {
					const integration = this.get('setIntegration')
					let pickupValue = this.get('pickupDate')
					let deliverValue = this.get('deliverDate')
					if (integration === 'FPG') {
						if (typeof pickupValue === 'string') {
							pickupValue = parse(pickupValue, 'MM-dd-yyyy', new Date())
						}
						if (typeof deliverValue === 'string') {
							deliverValue = parse(deliverValue, 'MM-dd-yyyy', new Date())
						}
						if (dateDiff(deliverValue, pickupValue) <= 1) {
							return true
						}
					}
					if (integration === 'TForce') {
						return false
					}
				},
				productClassDisabled() {
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						return true
					}
				},
				productClassRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
				},
				productCommodityDisabled() {
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						return true
					}
				},
				productWeightDisabled() {
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						return true
					}
				},
				productWeightRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
				},
				productPackageDimensionsDisabled() {
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						// Doesn't use product level packaging
						return true
					}
				},
				productPackageDimensionsRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
				},
				productPackageTypeDisabled() {
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						// Has no pay types
						return true
					}
				},
				productPackageTypeRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
					if (integration === 'TForce') {
						return false
					}
				},
				shipTypeRequired() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return true
					}
					if (integration === 'TForce') {
						return false
					}
				},
	/*
		Get and return integration specific choices for dropdowns
		Set any defaults
		accessorials, equipment type, container type, package type, pay type, ship type

	*/
				bookedShipmentErrorMessage() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return 'FPG Contact Info (702) 725-3100 Option 2 or email at ops@freightpartnersgroup.com'
					}				
				},
				consigneeAccessorialChoices() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return this.get('fpgAccessorialsStatic').filter(accessorial => accessorial.type === 'Consignee')
					}
				},
				// FPG assumes a pallet of length 48, width 40
				defaultContainerLengthHint() {
					const integration = this.get('setIntegration')
					const selectedContainer = this.get('selectedContainer')
					if (integration === 'FPG') {
						// Set any defaults
						if (selectedContainer === 'Pallets') {
							return '48'
						}
						return 'IN'
					}
					if (integration === 'TForce') {
						// Has no equipment types
						return "inches"
					}
				},
				defaultContainerWidthHint() {
					const integration = this.get('setIntegration')
					const selectedContainer = this.get('selectedContainer')
					if (integration === 'FPG') {
						// Set any defaults
						if (selectedContainer === 'Pallets') {
							if (selectedContainer === 'Pallets') {
								return '40'
							}						}
						return 'IN'
					}
					if (integration === 'TForce') {
						// Has no equipment types
						return "inches"
					}
				},
				defaultContainerHeightHint() {
					const integration = this.get('setIntegration')
					const selectedContainer = this.get('selectedContainer')
					if (integration === 'FPG') {
						// Set any defaults
						return 'IN'
					}
					if (integration === 'TForce') {
						// Has no equipment types
						return "inches"
					}
				},				
				defaultDimensionUnit() {
					// Used in placeholder text but also default for FPG units
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						// Set any defaults
						return 'IN'
					}
					if (integration === 'TForce') {
						// Has no equipment types
						return "inches"
					}
				},
				defaultWeightUnit() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						// Set any defaults
						return 'LBS'
					}
					return 'LBS'
				},
				equipmentTypeChoices() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						// Set any defaults
						this.set('selectedEquipmentType', 'Van-standard trailer')
						return this.get('fpgEquipmentStatic')
					}
					if (integration === 'TForce') {
						// Has no equipment types
						return []
					}
				},
				getSelectedContainerType() {
					// This is currently just for the summary display
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						// FPG supports but only works with the same container type
						return this.get('selectedContainer')
					}
					if (integration === 'TForce') {
						// TForce only supports one container
						const containerType = this.get('selectedContainer')
						if (containerType) {
							const containers = this.get('tforceContainers')
							const match = containers.find(container => container.shipmentcontainerid === containerType)
							return `${match.type} (${match.name}) `
						}

					}
				},
				packageTypeBoxChoices() {
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						return this.get('tforceContainers').filter(container => container.type === 'box')
					}
				},
				packageTypePalletChoices() {
					const integration = this.get('setIntegration')
					if (integration === 'TForce') {
						return this.get('tforceContainers').filter(container => container.type === 'pallet')
					}
				},
				packageTypeMiscChoices() {
					// Using misc for everything that's not in shipping table
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						// Map into something that resembles types from shipping table
						const misc = this.get('fpgPackageStatic').map(row => {
							return {
								name: row.description,
								shipmentcontainerid: row.description
							}
						})
						this.set('selectedContainer', 'Pallets')
						return misc
					}
				},
				payTypeChoices() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						// Set any defaults
						this.set('selectedPayType', 'Prepaid')
						return this.get('fpgPayTypeStatic')
					}
					if (integration === 'TForce') {
						// Has no pay types
						return []
					}
				},
				productPackageTypeChoices() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return this.get('fpgPackageStatic')
					}
					if (integration === 'TForce') {
						// Doesn't use product level package
						return []
					}
				},
				quoteTableColumns() {
					const integration = this.get('setIntegration')

					let columns = [
						{ property: 'service', name: 'Service' },
						{ property: 'carrierName', name: 'Carrier' },
						{ property: 'transitTime', name: 'Transit Time' },

					]
					if (integration === 'FPG') {
						columns.splice(3, 0, {
							property: 'total',
							name: 'Non-insured Rate',
							defaultSortColumn: true,
							defaultSortDirection: 'ASC'
						})
						columns.splice(4, 0, {
							property: 'markedUpInsuredTotal',
							name: 'Insured Rate',
						})
					}
					if (integration === 'TForce') {
						const useInsurance = this.get('useInsurance')
						if (useInsurance) {
							columns.splice(3, 0, {
								property: 'total',
								name: 'Non-insured Rate'
							})
							columns.splice(4, 0, {
								property: 'markedUpInsuredTotal',
								name: 'Insured Rate',
								defaultSortColumn: true,
								defaultSortDirection: 'ASC'
							})
						} else {
							columns.splice(3, 0, {
								property: 'total',
								name: 'Non-insured Rate',
								defaultSortColumn: true,
								defaultSortDirection: 'ASC'
							})
						}
					}
					return columns
				},
				shipperAccessorialChoices() {
					const integration = this.get('setIntegration')
					if (integration === 'FPG') {
						return this.get('fpgAccessorialsStatic').filter(accessorial => accessorial.type === 'Shipper')

					}
					if (integration === 'TForce') {
						const list = this.get('tforceAccessorials').map(row => {
							// Fpg returns 3 props, may be useful for others
							return {
								//type: row,
								abbreviation: row,
								description: row,
							}
						})
						return list
					}
				},
				shipTypeChoices() {
					const integration = this.get('setIntegration')
					// Set any defaults
					if (integration === 'FPG') {
						this.set('selectedShipType', 'Shipper')
						return this.get('fpgShipTypeStatic')
					}
					if (integration === 'TForce') {
						// Has no ship types
						return []
					}
				},
	/*
				Shared computed values
	*/
				calculateTotalWeight() {
					// Set any defaults
					const shipContainers = this.get('shipContainers')
					return shipContainers?.map(container => container.containerWeight).reduce((prev, next) => prev + next, 0)
				},

				overlength() {
					let length = this.get('length')
					let width = this.get('width')

					return Math.max(length ? length : 0, width ? width : 0) >= 96
				},
				// totalValue() {
				// 	let total = this.get('displaySaleLines')
				// 		.reduce((sum, line) => {
				// 			return financialNumber(sum)
				// 				.plus(line.total.toString())
				// 				.toString()
				// 		}, '0')

				// 	return total
				// },
				totalValue() {
					// Get shipment summary lines
					const containers = this.get('shipContainers')
					if (containers && containers.length) {
						// Get all the product lines from each container and flatten to a single array
						const productLines = containers.map(container => {
							return container.products
						}).flat()

						let total = productLines
							.reduce((sum, line) => {
								return financialNumber(sum)
									.plus(line.total.toString())
									.toString()
							}, '0')
						return total
					}
				},
				// Presumably gets only the description for maxed price item since TForce is just one line
				topDescription() {
					let maxPricedItem = this.get('displaySaleLines')
						.reduce((prev, current) => (prev.price > current.price) ? prev : current)

					return maxPricedItem.description
				},
				commodityDescription() {
					//selectedContainerCommodity
					const firstContainer = this.get('shipContainers')[0]
					const shipmentCommodityId = firstContainer.selectedContainerCommodity

					if (shipmentCommodityId === 'custom') {
						return this.get('customCommodityDescription')
					}

					const selectedCommodity = this.get('commodities')
						.find(commodity => commodity.shipmentcommodityid === shipmentCommodityId)

					if (selectedCommodity) {
						return selectedCommodity.name
					}

					return ''
				},
				selectedShipmentCommodityCode() {
					const shipmentCommodityId = this.get('selectedProductCommodityId')

					if (shipmentCommodityId === 'custom') {
						return this.get('customCommodityCode')
					}

					const selectedCommodity = this.get('commodities')
						.find(commodity => commodity.shipmentcommodityid === shipmentCommodityId)

					if (selectedCommodity) {
						return selectedCommodity.commoditycode
					}

					return ''
				},
				mapAddress() {
					const address = [
						this.get('salesOrder.shipStreet'),
						this.get('salesOrder.shipCity'),
						this.get('salesOrder.shipState'),
						this.get('salesOrder.shipZip'),
						this.get('salesOrder.shipCountry'),
					]

					return encodeURIComponent(address.join(' '))
				},

				quoteOnlyMode() {
					return this.get('postData.quoteOnlyMode') === 'True'
				},
				testingMode() {
					return this.get('postData.testingMode') === 'True'
				},
				possibleConfigError() {
					const accountNumber = this.get('postData.accountNumber').toUpperCase().trim()
					const billingLocationCode = this.get('postData.billingLocationCode').toUpperCase().trim()

					if (accountNumber === 'ACTRUCK') {
						return false
					}
					if (billingLocationCode !== `CRM${ accountNumber }B`) {
						return true
					}
					// TODO: add fpg config error
				},
				canRate() {
					return this.get('weight')
						&& this.get('shipClass')
						&& this.get('sourceStore.country')
						&& this.get('sourceStore.zip')
						&& this.get('salesOrder.shipCountry')
						&& this.get('salesOrder.shipZip')
				},
				canSchedule() {
					return this.get('selectedProductCommodityId')
						&& this.get('postData.scheduleShipmentPermission') === 'True'
				},
				scheduleShipmentPermission() {
					return this.get('postData.scheduleShipmentPermission') === 'True'
				},
				markupMultiplier() {
					return financialNumber(this.get('postData.markup'))
						.times('0.01')
						.plus('1')
						.toString()
				},
				// Modifies quote rows to add markup and insurance cost
				displayQuoteRows() {
					const integration = this.get('setIntegration')
					const markupMultiplier = this.get('markupMultiplier')
					const quoteRows = this.get('quoteRows')
					if (integration === 'FPG') {
						//DO THINGS
						return quoteRows.map(item => {
							// For FPG, insurance is always assumed but sometimes missing?
					 		// Prices come back with insurance already added
					 		let insuredTotal
					 		let markedUpInsuredTotal
					 		let nonInsuredTotal
							let markedUpTotal
							if (item.insuranceDetails) {
					 			insuredTotal = item.customerPrice.netPrice.toString()

					 			markedUpInsuredTotal = financialNumber(markupMultiplier)
					 				.times(insuredTotal)
					 				.changePrecision(2)
					 				.toString()

								// Need to remove insurance cost before markup
								nonInsuredTotal = financialNumber(item.customerPrice.netPrice.toString())
									.minus(item.insuranceDetails?.price.toString())
									.toString()

								markedUpTotal = financialNumber(markupMultiplier)
					 				.times(nonInsuredTotal)
					 				.changePrecision(2)
					 				.toString()		

							} else {
								const customerNetPrice = item.customerPrice.netPrice.toString()
					 			
								markedUpTotal = financialNumber(markupMultiplier)
					 				.times(customerNetPrice)
					 				.changePrecision(2)
					 				.toString()	
							}

							return {
								...item,
								total: item.customerPrice.netPrice, //for sorting purproses
								insuredTotal, //if insured, add insurance cost to total
								markedUpTotal, //if insured, add insurance cost to total times markup
								markedUpInsuredTotal	
							}
						})
					}
				
					if (integration === 'TForce') {
						return quoteRows
						.map(item => {
							let insuredTotal
							let markedUpInsuredTotal

							if (item.InsuredDetail) {
								insuredTotal = financialNumber(item.Total.toString())
									.plus(item.InsuredDetail.InsuranceCost.toString())
									.toString()

								markedUpInsuredTotal = financialNumber(markupMultiplier)
									.times(insuredTotal)
									.changePrecision(2)
									.toString()
							}

							const markedUpTotal = financialNumber(markupMultiplier)
								.times(item.Total.toString())
								.changePrecision(2)
								.toString()

							return {
								...item,
								total: item.Total, //for sorting purproses
								insuredTotal, //if insured, add insurance cost to total
								markedUpTotal, //if insured, add insurance cost to total times markup
								markedUpInsuredTotal
							}
						})

					}

				},
				displayQuote() {
					const markupMultiplier = this.get('markupMultiplier')

					return this.get('quote')
						.map(item => {
							let insuredTotal
							let markedUpInsuredTotal

							if (item.InsuredDetail) {
								insuredTotal = financialNumber(item.Total.toString())
									.plus(item.InsuredDetail.InsuranceCost.toString())
									.toString()

								markedUpInsuredTotal = financialNumber(markupMultiplier)
									.times(insuredTotal)
									.changePrecision(2)
									.toString()
							}

							const markedUpTotal = financialNumber(markupMultiplier)
								.times(item.Total.toString())
								.changePrecision(2)
								.toString()

							return { ...item,
								insuredTotal, //if insured, add insurance cost to total
								markedUpTotal, //if insured, add insurance cost to total times markup
								markedUpInsuredTotal
							}
						})
				},
				hasApiError() {
					return this.get('hasRateErrorMessage')
						|| this.get('hasShipmentErrorMessage')
				},
				isApiLoading() {
					return this.get('creatingShipment')
						|| this.get('quoteLoading')
				},
				loadingContext() {
					if (this.get('quoteLoading')) {
						return 'quote'
					} else if (this.get('creatingShipment')) {
						return 'shipment'
					}
					return ''
				},
				// ratesTableColumns() {
				// 	const useInsurance = this.get('useInsurance')

				// 	const additionalRateProperties = useInsurance ? {} : { defaultSortColumn: true }

				// 	let columns = [
				// 		{ property: 'CarrierName', name: 'Carrier Name' },
				// 		{ property: 'ServiceDays', name: 'Service Days' },
				// 		{ property: 'Total', name: 'Rate', ...additionalRateProperties },
				// 	]

				// 	if (useInsurance) {
				// 		columns.splice(3, 0, {
				// 			property: 'insuredTotal',
				// 			name: 'Insured Rate',
				// 			defaultSortColumn: true,
				// 		})
				// 	}

				// 	return columns
				// },
			},
			oninit() {
				const postData = this.get('postData')
				// Set the selected integration which dictates menu data loading and various UI component visibility
				//this.set('setIntegration', postData.shippingSource)
				// TODO: Not sure why I do this here
				this.set('fpgClientRefNum', postData.companyCode)
				const salesOrder = this.get('salesOrder')

				if (postData.testingMode === 'True') {
					console.log('Debug Post Data: ', postData)
					console.log('Debug Shipping Integration: ', this.get('setIntegration'))
					//const junk = JSON.stringify(postData, null, 2)
					const junk = JSON.stringify(salesOrder, null, 2)
					this.set('junk', junk)
					const products = this.get('displaySaleLines')
					console.log('test')
					console.log('products: ', products)
				}
				const products = this.get('displaySaleLines')
				console.log('test')
				console.log('products: ', products)
				//const products = this.get('salesOrder.salesOrderLines')
				// Add displayed sales order lines into a default container
				let shippingContainers = []
				shippingContainers.push({
					products,
				})
				this.set('shipContainers', shippingContainers)
				// Set today's date for pickup default
				const today = new Date()
				const todayFormatted = format(today, 'MM-dd-yyyy')
				this.set('pickupDate', todayFormatted)
				const twoBusinessDays = addBusinessDays(today, 2)
				this.set('deliverDate', format(twoBusinessDays, 'MM-dd-yyyy'))
				// This was 10 levels of awful to figure out
				this.on('pickup-stepper-clicked', (context, increment)=> {
					let value = this.get('pickupDate')
					if (typeof value === 'string') {
						value = parse(value, 'MM-dd-yyyy', new Date())
					}
					const newValue = addDays(value, increment)
					const formattedValue = format(newValue, 'MM-dd-yyyy')
					this.set({
						pickupDate: formattedValue,
					})
				})
				this.on('deliver-stepper-clicked', (context, increment)=> {
					let value = this.get('deliverDate')
					if (typeof value === 'string') {
						value = parse(value, 'MM-dd-yyyy', new Date())
					}
					const newValue = addDays(value, increment)
					const formattedValue = format(newValue, 'MM-dd-yyyy')
					this.set({
						deliverDate: formattedValue,
					})
				})
			},
			// Shared Functions
			// Main get rates button to call integration specific getRates
			getRates() {
				const ractive = this
				// Get current integration
				const integration = ractive.get('setIntegration')
				// Setup fetch urls and create request body by integration
				let fetchPath
				let requestData
				switch (integration) {
					case 'FPG':
						fetchPath = 'server/get_quote_fpg.php'
						const data = ractive.getFpgShipmentData('Quoted')
						data.clientRefNum = ractive.get('fpgClientRefNum')
						data.testingMode = ractive.get('postData.testingMode')
						// Add testing mode flag for auth to pick right creds
						requestData = data
					break
					case 'TForce':
						fetchPath = 'server/get_quote_tforce.php'
						requestData = ractive.getDlsShipmentData('rate')
					break
					default:
						console.log('No valid integration chosen')
				}
				if(ractive.get('postData.testingMode') === 'True') {
					console.log('Debug quote request body: ', JSON.stringify(requestData, null, 2))
				}
				// Show loading icon, shipment modal
				ractive.set({
					quoteLoading: true, // sets loadingContext() between quote and shipment
					showShipmentModal: true,
					displayQuotes: true, // not sure on this one
					shipmentModalTitle: 'Shipping Rates'
				}).then(() => {
					fetch(fetchPath, {
						method: "POST",
						mode: "cors",
						cache: "no-cache",
						credentials: "same-origin",
						headers: {
							"Content-Type": "application/json; charset=utf-8",
						},
						redirect: "follow",
						referrer: "no-referrer",
						body: JSON.stringify(requestData),
					})
						.then(resp => {
							return resp.json()
						})
						.then(jsonResponse => {
							console.log('quote response: ', jsonResponse)
							ractive.quoteResponseHandler(jsonResponse)
							// Error handled above, otherwise display quote

						})
				})
			},
			quoteResponseHandler(jsonResponse) {
				const integration = this.get('setIntegration')
				// If there's an error, set the error message and disable quoteLoading, otherwise return the original response
				let modifiedQuoteRows
				switch (integration) {
					case 'FPG':
						// Handle error if exists
						if (!jsonResponse || jsonResponse.traceId || jsonResponse.title === "Bad Request") {
							const quoteErrorObject = {
								status: jsonResponse.status,
								title: jsonResponse.title,
								errors: JSON.stringify(jsonResponse.errors),
							}
							this.set({
								hasRateErrorMessage: quoteErrorObject,
								quoteLoading: false,
							})
							return
						}
						// standardize quote rows to pass to modifyQuoteRows
						//console.log('quotes: ', jsonResponse.quotes)
						modifiedQuoteRows = jsonResponse.quotes

					break
					case 'TForce':
						// If we have a Message property, it's an error
						if (!jsonResponse || jsonResponse.Message) {
							const quoteErrorObject = {
								status: '',
								title: '',
								errors: !jsonResponse || jsonResponse.Message === 'An error has occurred.' ? dlsNoResponse : jsonResponse.Message
							}
							this.set({
								hasRateErrorMessage: quoteErrorObject,
								quoteLoading: false,
							})
							return
						}
						// modify rows
						modifiedQuoteRows = jsonResponse.map(row => {
							return {
								...row,
								// TODO: not sure if this is accurate
								service: 'LTL',
								carrierName: row.CarrierName,
								transitTime: row.ServiceDays,
							}
						})
					break

				}
				this.set({
					quote: jsonResponse, // This also changes button
					quoteRows: modifiedQuoteRows,
					hasRateErrorMessage: false,
					quoteLoading: false,
					displayQuotes: true,
				})
			},

			getFpgShipmentData(requestType) {
				const ractive = this
				const salesOrder = ractive.get('salesOrder')
				const sourceStore = ractive.get('sourceStore')
				const postData = ractive.get('postData')
				let shipperContact = {}
				const sourceStoreContact = ractive.get('sourceStore.contact')
				if (sourceStoreContact) {
					shipperContact = this.splitName(sourceStoreContact)
				} else {
					shipperContact = {
						firstName: 'FPG',
						lastName: 'Operations',
					}
				}
				shipperContact = this.splitName(sourceStoreContact)
				const shipperLocation = {
					companyName: sourceStore.name ? sourceStore.name : 'FPG Operations',
					locationName: sourceStore.name ? sourceStore.name : 'FPG Operations',
					contactMethods: {
						phoneNumber: sourceStore.phone ? sourceStore.phone : '702-425-3100',
						email: postData.contactEmail ? postData.contactEmail : 'ops@freightpartnersgroup.com',
					},
					contactPerson: shipperContact,
					address: {
						lineOne: sourceStore.address,
						city: sourceStore.city,
						stateOrProvince: sourceStore.state,
						zipCode: sourceStore.zip,
						country: sourceStore.country,
					},

				}
				const consigneeLocation = {
					companyName: salesOrder.shipCompany ? salesOrder.shipCompany : salesOrder.shipContact,
					locationName: salesOrder.shipCompany ? salesOrder.shipCompany : salesOrder.shipContact,
					contactPerson: this.splitName(salesOrder.shipContact),
					contactMethods: {
						phoneNumber: salesOrder.shipPhone ? salesOrder.shipPhone : '702-425-3100',
						email: salesOrder.shipEmail ? salesOrder.shipEmail : 'ops@freightpartnersgroup.com',
					},
					address: {
						lineOne: salesOrder.shipStreet,
						city: salesOrder.shipCity,
						stateOrProvince: salesOrder.shipState,
						zipCode: salesOrder.shipZip,
						country: salesOrder.shipCountry,
					},
				}
				const conditionIsNew = ractive.get('condition')
				const selectedShipperAccessorials = ractive.get('selectedShipperAccessorials')
				const selectedCosigneeAccessorials = ractive.get('selectedCosigneeAccessorials')
				let insuredValue
				if (ractive.get('insuredValue') === '0.00') {
					insuredValue = ractive.get('totalValue')
				} else {
					insuredValue = ractive.get('insuredValue')
				}
				const shipmentData = {
					shipperAccessorials: selectedShipperAccessorials ? selectedShipperAccessorials.map(row => {
						return {
							abbreviation: row.abbreviation,
						}
					}) : [],
					consigneeAccessorials: selectedCosigneeAccessorials ? selectedCosigneeAccessorials.map(row => {
						return {
							abbreviation: row.abbreviation
						}
					}) : [],
					insuranceInfo: {
						vendor: "FALVEY",
						commodityType: "General",
						commodityCondition: conditionIsNew !== 'False' ? "New" : "Used",
						insuredValue,
					},
					consigneeLocation,
					actualDelivery: ractive.convertStringToDate(ractive.get('deliverDate')),
					actualPickup: ractive.convertStringToDate(ractive.get('pickupDate')),
					estimatedDelivery: ractive.convertStringToDate(ractive.get('deliverDate')),
					estimatedPickup: ractive.convertStringToDate(ractive.get('pickupDate')),
					handlingUnits: ractive.getFpgHandlingUnits(),
					//TODO: check getFpgShippingServices
					invoiceId: `${salesOrder.storeID }-${ salesOrder.salesOrderID}`,
					payType: ractive.get('selectedPayType'),
					packageInfo: {
						routeNumber: "",
						cod: 0,
						declaredLiability: 0,
					},
					referenceFields: [],
					shipmentServices: ractive.getFpgShippingServices(),
					shipperLocation,
					shipType: ractive.get('selectedShipType'),
					useDefaultBillTo: true,
				}
				return {
					carrierScac: "",
					importAsStatus: requestType, // Pending, Quoted and Booked
					isEzRate: false,
					quoteNumber: "",
					shouldRunRates: true,
					shipmentData,
					waitForRates: true, //example shows false
				}
			},
			// Misc
			canGetFpgRates() {
				// Check various required fields and return false and error text if missing
				// Check the Additional details rows
				const sourceStore = this.get('sourceStore')
				const salesOrder = this.get('salesOrder')
				const payType = this.get('selectedPayType')
				const shipType = this.get('selectedShipType')
				const pickupDate = this.get('pickupDate')
				const deliverDate = this.get('deliverDate')
				const equipmentType = this.get('selectedEquipmentType')
				const shipperContactName = this.get('sourceStore.contact')
				const cosigneeContactName = this.get('salesOrder.shipContact')
				// Check the Shipment Data Rows
				const shipContainers = this.get('shipContainers')
				// Needed this to get around a minor ractive error
				if (!shipContainers) {
					return false
				}
				if (!shipperContactName) {
					this.set('getRatesErrorMessage', '* Store missing contact name')
					return false
				}
				if (!sourceStore.address || !sourceStore.city || !sourceStore.state || !sourceStore.zip) {
					this.set('getRatesErrorMessage', '* Store missing address information: address, city, state, zip required')
					return false
				}
				if (!salesOrder.shipContact) {
					this.set('getRatesErrorMessage', '* Destination missing contact name')
					return false					
				}
				if (!salesOrder.shipStreet || !salesOrder.shipCity || !salesOrder.shipState || !salesOrder.shipZip) {
					this.set('getRatesErrorMessage', '* Destination missing address information: address, city, state, zip required')
					return false
				}
				if (!cosigneeContactName) {
					this.set('getRatesErrorMessage', '* Destination missing contact name')
					return false
				}
				// If any of the containers are missing required fields, return false and error text
				for (const container of shipContainers) {
					if (!container.containerWeight) {
						this.set('getRatesErrorMessage', '* Container(s) missing required fields')
						return false
					}
					for (const product of container.products) {
						if (!product.classWeight?.productShipClass || !product.inventory?.weight || !product.dimensions?.selectedProductPackageType  || !product.inventory?.shippingLength || !product.inventory?.shippingWidth || !product.inventory?.shippingHeight) {
							this.set('getRatesErrorMessage', '* Product(s) missing required fields')
							return false
						}
					}
				}

				if (!payType || !shipType || !pickupDate || !deliverDate || !equipmentType) {
					this.set('getRatesErrorMessage', '* Required fields missing')
					return false
				}

				this.set('getRatesErrorMessage', '')
				return true
			},
			canGetTforceRates() {
				const container = this.get('shipContainers')
				if (!container) {
					return false
				}
				const { containerWeight, containerShipClass } = container[0]
				return containerWeight
					&& containerShipClass
					&& this.get('sourceStore.country')
					&& this.get('sourceStore.zip')
					&& this.get('salesOrder.shipCountry')
					&& this.get('salesOrder.shipZip')
			},
			countryMagic(countryName = '') {
				countryName = countryName.toUpperCase().trim()

				const defaultCountry = 'USA'

				if (!countryName) {
					return defaultCountry
				}
				const countries = this.get('countries')
				const matchingCountry = countries
					.find(country => country.name.toUpperCase() === countryName)

				return matchingCountry ? matchingCountry.code : defaultCountry
			},
			excludeProduct() {
				const shipContainers = this.get('shipContainers')
				let newItems = []
				for (const [ containerIndex, container ] of shipContainers.entries()) {
					let i = container.products.length
					//const containerOriginalIndex = container.originalIndex
					while (i--) {
						if (container.products[i].toMove) {
							// Add item to newItems array
							// Get the originalIndex of the product
							// Reset the flag on that product
							container.products[i].toMove = false
							// Move product to newItems array
							newItems.push(container.products[i])

							// Remove item from original container product list
							this.splice(`shipContainers[${containerIndex}].products`, i, 1)

						}

					}
					// Check if containers are empty and remove them

					if (!container.products.length) {
						this.splice('shipContainers', containerIndex, 1)
					}
				}
				this.push('excludedItems', ...newItems)
				// containers wouldn't update without this
				//this.update('shipContainers')
			},
			moveProducts(toMoveContainerIndex) {
				let shipContainers = this.get('shipContainers')
				let productsToMove = []
				// Loop through any excluded items
				const excludedItems = this.get('excludedItems')
				if (excludedItems?.length) {
					let i = excludedItems.length
					while (i--) {
						if (excludedItems[i].toMove) {
							const itemToMove = excludedItems[i]
							itemToMove.toMove = false
							// Add item to newItems array
							//excludedItems[i].toMove = false
							//productsToMove.push(excludedItems[i])
							productsToMove.push(itemToMove)
							// Remove item from original container product list
							this.splice('excludedItems', i, 1)
							this.push(`shipContainers[${toMoveContainerIndex}].products`, itemToMove)
						}
					}
				}
				for (const [ containerIndex, container ] of shipContainers.entries()) {
					let i = container.products.length
					while (i--) {
						if (container.products[i].toMove) {
							// Reset flag

							let productToMove = container.products[i]

							productToMove.toMove = false
							// Move product to newItems array
							productsToMove.push(container.products[i])

							// Add product to the new container
							this.push(`shipContainers[${toMoveContainerIndex}].products`, productToMove)
							// Then remove the product from the original container
							this.splice(`shipContainers[${containerIndex}].products`, i, 1)
						}

					}
					if (!container.products.length) {
						this.splice('shipContainers', containerIndex, 1)
					}
				}
			},
			addShipContainer() {
				let shipContainers = this.get('shipContainers')
				//console.log('shipContainers', shipContainers)
				let newItems = []
				const excludedItems = this.get('excludedItems')
				if (excludedItems?.length) {
					let i = excludedItems.length
					while (i--) {
						if (excludedItems[i].toMove) {
							const itemToMove = excludedItems[i]
							itemToMove.toMove = false
							// Add item to newItems array
							//excludedItems[i].toMove = false
							//productsToMove.push(excludedItems[i])
							newItems.push(itemToMove)
							// Remove item from original container product list
							this.splice('excludedItems', i, 1)
						}
					}
				}
				for (const [ containerIndex, container ] of shipContainers.entries()) {
					let i = container.products.length
					while (i--) {
						if (container.products[i].toMove) {
						// Add item to newItems array
							container.products[i].toMove = false
							newItems.push(container.products[i])
							// Remove item from original container product list
							this.splice(`shipContainers[${containerIndex}].products`, i, 1)
							// If the container is empty, remove it
							if (this.get('shipContainers')[containerIndex].products.length === 0) {
								this.splice('shipContainers', containerIndex, 1)
							}
						}
					}
				}
				this.push('shipContainers', { products: newItems })
			},
			calculateAdditionalWeight() {
				// FPG considers the weight of the products but the containers also have a weight input
				const shipContainers = this.get('shipContainers')
				const containerWeightTotal = shipContainers.map(container => container.containerWeight).reduce((prev, next) => prev + next, 0)

				const productArray = shipContainers.map(container => container.products).flat()
				const productWeightTotal = productArray.map(product => product.inventory.weight).reduce((prev, next) => prev + next, 0)

				if (containerWeightTotal && productWeightTotal) {
					return parseFloat(containerWeightTotal) - parseFloat(productWeightTotal)
				}
				return 0
			},
			getFpgShippingServices() {
				let fpgShipServices = []

				const equipmentType = this.get('selectedEquipmentType')
				const specialInstructions = this.get('specialInstructions')
				const additionalWeight = this.calculateAdditionalWeight()
				const quantity = this.get('shipContainers').length
				const weightUnitOfMeasurement = this.get('defaultWeightUnit')
				const packageType = this.get('selectedContainer')
				// TODO: make sure weight units are preference/used universally
				// Dimensions not added b/c they don't work as expected when totalling
				// FPG says to also always pass parcel and last mile
				fpgShipServices.push({
					equipmentType,
					packageType,
					serviceMode: 'LTL',
					additionalWeight,
					weightUnitOfMeasurement,
					quantity,
					specialInstructions,
				})
				fpgShipServices.push({
					equipmentType,
					packageType,
					serviceMode: 'Parcel',
					// additionalWeight: additionalWeight ? additionalWeight : 0,
					additionalWeight,
					weightUnitOfMeasurement,
					quantity,
					specialInstructions,
				})
				fpgShipServices.push({
					equipmentType,
					packageType,
					serviceMode: 'Final Mile',
					// additionalWeight: additionalWeight ? additionalWeight : 0,
					additionalWeight,
					weightUnitOfMeasurement,
					quantity,
					specialInstructions,
				})
				return fpgShipServices
			},
			// For FPG, a handling unit is a shipping unit/container with products
			getFpgHandlingUnits() {
				// Get the fpg container lines which should also include products
				const shipContainerRows = this.get('shipContainers')
				if (this.get('postData.testingMode') === 'True') {
					console.log('Debug Fpg ship rows: ', shipContainerRows)
				}

				//const dimensionUnit = this.get('defaultDimensionUnit')
				//const weightUnit = this.get('defaultWeightUnit')
				const handlingUnits = shipContainerRows.map(container => {
					const products = container.products.map(product => {
						return {
							packageType: product.dimensions.selectedProductPackageType,
							quantity: product.quantity,
							class: product.classWeight.productShipClass,
							weight: product.inventory?.weight,
							weightUnitOfMeasurement: this.get('defaultWeightUnit'),
							dimensions: {
								unitOfMeasurement: this.get('defaultDimensionUnit'),
								length: product.inventory?.shippingLength,
								width: product.inventory?.shippingWidth,
								height: product.inventory?.shippingHeight,

							},
							description: product.description ? product.description : 'n/a',
						}
					})
					let shippingContainerDimensions
					// if length and width, set shippingContainerDimensions

					let handlingUnit = {
						packageType: this.get('selectedContainer'),
						quantity: container.quantity || 1,
						products,
					}
					// Only need to set this if changed, otherwise a default pallet size is apparently assumed for FPG
					// if (container.containerLength && container.containerWidth) {
					// 	handlingUnit.length = container.containerLength
					// 	handlingUnit.width = container.containerWidth
					// 	handlingUnit.height = container.containerHeight
					// }
					const defaultContainerLength = this.get('defaultContainerLengthHint')
					const defaultContainerWidth = this.get('defaultContainerWidthHint')
					handlingUnit.length = container.containerLength ? container.containerLength : defaultContainerLength 
					handlingUnit.width = container.containerWidth ? container.containerWidth : defaultContainerWidth 

					const containerProductsWeight = container.products.map(product => product.inventory.weight).reduce((prev, next) => prev + next, 0)
					handlingUnit.unitOfMeasurement = this.get('defaultDimensionUnit')
					handlingUnit.weightUnitOfMeasurement = this.get('defaultWeightUnit')
					handlingUnit.additionalWeight = container.containerWeight - containerProductsWeight
					return handlingUnit
					// return {
					// 	packageType: this.get('selectedContainer'),
					// 	quantity: container.quantity || 1,
					// 	products,
					// 	dimensions: shippingContainerDimensions,
					// }
				})
				return handlingUnits
			},
			// FPG requires first/last name, this attempts to split the name and provide something for both
			splitName(name) {
				const [ first, ...last ] = name.split(' ').filter(Boolean)
				return {
					firstName: first,
					lastName: last.join(' ',) || first
				}
			},
			getDlsShipmentData(requestType) {
				const ractive = this

				const salesOrder = ractive.get('salesOrder')
				const sourceStore = ractive.get('sourceStore')
				const shipContainer = this.get('shipContainers')[0]
				const selectedShipperAccessorials = this.get('selectedShipperAccessorials')
				let accessorialCharges = {
					residential: false,
					lift: false,
					limited: false,
					construction: false,
					overlength: false,
					hazardous: false,
					inside: false,
				}
				// Doing another hinky thing to return similar object as vanilla
				if (selectedShipperAccessorials.length) {
					for (const [key, value] of Object.entries(accessorialCharges)) {
						if (selectedShipperAccessorials.find(row => row.description === key)) {
							accessorialCharges[key] = true
						}
					}
				}
				return { requestType,

					sourceCompany: sourceStore.name,
					sourceAddress: sourceStore.address,
					sourceCity: sourceStore.city,
					sourceState: sourceStore.state,
					sourceZip: sourceStore.zip,
					sourceCountry: sourceStore.country,
					sourcePhone: sourceStore.phone,
					sourceContact: sourceStore.contact,

					destinationCompany: salesOrder.shipCompany,
					destinationAddress: salesOrder.shipStreet,
					destinationCity: salesOrder.shipCity,
					destinationState: salesOrder.shipState,
					destinationZip: salesOrder.shipZip,
					destinationCountry: salesOrder.shipCountry,
					destinationPhone: salesOrder.shipPhone,
					destinationContact: salesOrder.shipContact,

					length: shipContainer.containerLength,
					width: shipContainer.containerWidth,
					height: shipContainer.containerHeight,
					weight: shipContainer.containerWeight,
					class: shipContainer.containerShipClass,
					commodity: shipContainer.selectedContainerCommodity,
					accessorialCharges,
					insuredValue: ractive.get('insuredValue'),
					getInsuredRate: ractive.get('useInsurance'),
					orderValue: ractive.get('totalValue'),
					description: ractive.get('topDescription'),
					commodityDescription: ractive.get('commodityDescription'),
					specialInstructions: ractive.get('specialInstructions'),

					inventoryStoreId: salesOrder.storeID,

					dates: ractive.getTForceDates(),  // Using what already exists for now

					referenceNumber: `${salesOrder.storeID }-${ salesOrder.salesOrderID}`,
					purchaseOrderNumber: salesOrder.purchaseOrderNumber,
					documentId: salesOrder.salesOrderID,
					documentStoreId: salesOrder.storeID,

					document: '', ...ractive.get('postData') }
			},
			pad(val) {
				return val < 10 ? `0${ val}` : val
			},
			// Not sure if there will be problems not setting a time beyond 0:00
			convertStringToDate(dateString) {
				if (typeof dateString === 'string') {
					return new Date(dateString).toISOString()
				}
			},
			getTForceDates() {
				const today = new Date()

				const dateString = [
					this.pad(today.getMonth() + 1),
					this.pad(today.getDate()),
					today.getFullYear(),
				].join('/')

				const startDateTime = `${dateString }, 8:00 AM`
				const endDateTime = `${dateString }, 5:00 PM`

				return {
					current: new Date().toLocaleString().replace(/\u200E/g, ''),

					epd: startDateTime,
					lpd: endDateTime,

					edd: startDateTime,
					ldd: endDateTime,
				}
			},
			addShipperAccessorial() {
				const ractive = this
				// Get the obj from form
				const selectedShipperAccessorial = ractive.get('selectedShipperAccessorial')
				// Get current list then check if duplicate
				const selectedShipperAccessorials = ractive.get('selectedShipperAccessorials')
				// If there aren't any, add to new arr
				if (!selectedShipperAccessorials) {
					ractive.push('selectedShipperAccessorials', selectedShipperAccessorial)
				} else {
					// Abbreviation is the only unique thing in FPG accessorials, use for all I guess?
					const duplicate = selectedShipperAccessorials.find(accessorial => accessorial.abbreviation === selectedShipperAccessorial.abbreviation)
					if (!duplicate) {
						// Add to list
						ractive.push('selectedShipperAccessorials', selectedShipperAccessorial)
					}
				}
			},
			addCosigneeAccessorial() {
				const ractive = this
				// Get the obj
				const selectedCosigneeAccessorial = ractive.get('selectedCosigneeAccessorial')
				// Get current list then check if duplicate
				const selectedCosigneeAccessorials = ractive.get('selectedCosigneeAccessorials')
				if (!selectedCosigneeAccessorials) {
					ractive.push('selectedCosigneeAccessorials', selectedCosigneeAccessorial)
				} else {
					const duplicate = selectedCosigneeAccessorials.find(accessorial => accessorial.abbreviation === selectedCosigneeAccessorial.abbreviation)
					if (!duplicate) {
						// Add to list
						ractive.push('selectedCosigneeAccessorials', selectedCosigneeAccessorial)
					}
				}
			},
			getFpgBol() {
				const ractive = this
				const bookedShipment = ractive.get('bookedShipment')
				const documentDetails = {
					loadId: bookedShipment.loadId,
					clientRefNum: ractive.get('fpgClientRefNum'),
					testingMode: ractive.get('postData.testingMode'),
					documentType: 'Banyan_BOL'
				}
				ractive.set({
					fpgDocumentLoading: true,
				}).then(() => {
					fetch('server/get_fpg_documents.php', {
						method: "POST",
						mode: "cors",
						cache: "no-cache",
						credentials: "same-origin",
						headers: {
							"Content-Type": "application/json; charset=utf-8",
						},
						redirect: "follow",
						referrer: "no-referrer",
						body: JSON.stringify(documentDetails),
					})
						.then(resp =>
							resp.json(),
						)
						.then(thing => {
							// If we have errorMessage property, then we have a FPG error we can display
							if (thing.errorMessage) {
								ractive.set({
									fpgDocumentLoading: false,
									fpgDocumentError: thing.errorMessage,
								})
								return
							}
							//console.log('bol response final: ', thing)
							ractive.displayPdf(thing.image, 1.9)
							// TODO: at some point, reset the fpgQuote object to empty
						})
				})
			},
			getFpgEshipperLabel() {
				const ractive = this
				const bookedShipment = ractive.get('bookedShipment')
				const documentDetails = {
					loadId: bookedShipment.loadId,
					clientRefNum: ractive.get('fpgClientRefNum'),
					testingMode: ractive.get('postData.testingMode'),
					documentType: 'Carrier_Label',
				}
				//Banyan_BOL  Carrier_Label
				ractive.set({
					fpgDocumentLoading: true,
				}).then(() => {
					fetch('server/get_fpg_documents.php', {
						method: "POST",
						mode: "cors",
						cache: "no-cache",
						credentials: "same-origin",
						headers: {
							"Content-Type": "application/json; charset=utf-8",
						},
						redirect: "follow",
						referrer: "no-referrer",
						body: JSON.stringify(documentDetails),
					})
						.then(resp =>
							resp.json(),
						)
						.then(thing => {
							// If we have errorMessage property, then we have a FPG error we can display
							if (thing.errorMessage) {
								ractive.set({
									fpgDocumentLoading: false,
									fpgDocumentError: thing.errorMessage,
								})
								return
							}
							//console.log('bol response final: ', thing)
							ractive.displayPdf(thing.image, 1.9)
							// TODO: at some point, reset the fpgQuote object to empty
						})
				})
			},
			priceMarkup() {
				const stuff = this.get('bookedShipment.awardedQuotePricing.customer')
				console.log('stuff: ', stuff)
				const markupMultiplier = this.get('markupMultiplier') 
				console.log('debug passed total: ', passedTotal)
				console.log('debug markup: ', markupMultiplier)
				const markedUpTotal = financialNumber(markupMultiplier)
					.times(passedTotal)
					.changePrecision(2)
					.toString()

				console.log('marked up: ', markedUpTotal)
				return markedUpTotal
			},
			updateQuote() {
				const integration = this.get('setIntegration')
				// FPG can update an existing quote
				if (integration === 'FPG') {
					this.updateFpgQuote()
				}
				// TForce can only submit a new one
				if (integration === 'TForce') {
					// Submit a new quote
					this.getRates()
				}
			},
			updateFpgQuote() {
				const ractive = this

				// Get quote id
				const quote = ractive.get('quote')
				const { loadId } = quote
				// Get data again, hopefully with updated values
				let data = ractive.getFpgShipmentData('Quoted')
				// Add quoteId to request, to be removed later
				data.loadId = loadId
				data.clientRefNum = ractive.get('fpgClientRefNum')
				data.testingMode = ractive.get('postData.testingMode')

				if(ractive.get('postData.testingMode') === 'True') {
					console.log('Debug quote update request body: ', JSON.stringify(data, null, 2))
				}
				ractive.set({
					shipmentModalTitle: 'Shipping Rates',
					quoteLoading: true, // Show loading spinner
					showShipmentModal: true, // Show quote and book modal
					displayQuotes: true, // Make sure we don't show quotes after book is successful
				}).then(() => {
					fetch('server/update_shipment_fpg.php', {
						method: "POST",
						mode: "cors",
						cache: "no-cache",
						credentials: "same-origin",
						headers: {
							"Content-Type": "application/json; charset=utf-8",
						},
						redirect: "follow",
						referrer: "no-referrer",
						body: JSON.stringify(data),
					})
						.then(resp => {
							return resp.json()
						})
						.then(jsonResponse => {
							ractive.quoteResponseHandler(jsonResponse)
						})
				})
			},
			bookShipment(selectedQuote, acceptInsurance) {
				const integration = this.get('setIntegration')
				// FPG will return a response with status details
				if (integration === 'FPG') {
					this.bookFpgShipment(selectedQuote, acceptInsurance)
				}
				// TForce goes straight to returning a BOL
				if (integration === 'TForce') {
					// Submit a new quote
					this.bookTforceShipment(selectedQuote, acceptInsurance)
				}
			},
			bookFpgShipment(selectedQuote, acceptInsurance) {
				const ractive = this
				const dispatchDisabled = ractive.get('dispatchDisabled')
				// Get the shipment data
				const quote = ractive.get('quote')
				console.log('quote: ', quote)
				const { loadId } = quote
				// Get the quote id and Standard Carrier Alpha Code
				const { quoteId, scac } = selectedQuote
				// Add the quote id and scac to the data for update
				// TODO: change these on testing flag


				const data = {
					//carrierScac: scac,
					quoteId,
					acceptInsurance,
					dispatch: dispatchDisabled ? false : true,
					dispatchOverride: false,
					loadId,
					submitPickupRequest: dispatchDisabled ? false : true,
					clientRefNum: ractive.get('fpgClientRefNum'),
					testingMode: ractive.get('postData.testingMode')

				}
				if (ractive.get('testingMode')) {
					console.log('Debug fpg book shipment data before post: ', data)
				}
				ractive.set({
					creatingShipment: true,
				}).then(() => {
					fetch('server/book_quote_fpg.php', {
						method: "POST",
						mode: "cors",
						cache: "no-cache",
						credentials: "same-origin",
						headers: {
							"Content-Type": "application/json; charset=utf-8",
						},
						redirect: "follow",
						referrer: "no-referrer",
						body: JSON.stringify(data),
					})
						.then(resp => {
							return resp.json()
						})
						.then(shipment => {
							//If we have a Message property, it's an error
							console.log('Debug fpg book response: ', shipment)

							// TODO: data to display back?
							// bolNumber, dispatchResponse, delivery dates

							if (!shipment || shipment.Message) {
								ractive.set({
									hasShipmentErrorMessage: !shipment || shipment.Message === 'An error has occurred.' ?
										dlsNoResponse : shipment.Message,
									creatingShipment: false,
								})
								return
							}
							// Check service type
							const quoteMatch = quote.quotes.find(quote => quote.quoteId === quoteId)
							const quoteService = quoteMatch.service 
							if (quoteService === 'PARCEL') {
								ractive.set('showEshipperButton', true)
							}
							ractive.set({
								displayQuotes: false, // disable quote list
								shipmentModalTitle: 'Booked Shipment Details',
								//fpgShipment: shipment,
								bookedShipment: shipment,
								hasShipmentErrorMessage: false,
								creatingShipment: false,
								booked: true,
								displayBookResponse: true,
								//showEshipperButton: true
							})
						})
				})
				// These are for testing a saved response
				// ractive.set({
				// 	//bookingFpgShipment: true,
				// 	showFpgShipmentModal: true, // only for testing
				// 	bookedShipmentModalTitle: 'Booking Shipment',
				// 	displayFpgQuotes: false, //disable quote list
				// 	bookedShipment: testFpgBookResponse,
				// 	hasShipmentErrorMessage: false,
				// 	creatingShipment: false,
				// 	bookingFpgShipment: false,
				// 	displayFpgBookResponse: true,
				// 	//showDlsConfirmShipmentModal: false,
				// })
			},
			bookTforceShipment(selectedShipment, useInsurance) {
				const ractive = this

				let creatingShipmentContext = {
					carrierName: selectedShipment.CarrierName,
					insured: useInsurance,
				}

				if (useInsurance) {
					creatingShipmentContext.amount = currency.format(selectedShipment.markedUpInsuredTotal)
				} else {
					creatingShipmentContext.amount = currency.format(selectedShipment.markedUpTotal)
				}

				const { Scac, Mode, Service } = selectedShipment

				const data = { ...ractive.getDlsShipmentData('shipment'), Scac,
					Mode,
					Service,
					useInsurance }

				ractive.set({
					creatingShipment: true,
					creatingShipmentContext,
				}).then(() => {
					fetch('server/get_quote_tforce.php', {
						method: "POST",
						mode: "cors",
						cache: "no-cache",
						credentials: "same-origin",
						headers: {
							"Content-Type": "application/json; charset=utf-8",
						},
						redirect: "follow",
						referrer: "no-referrer",
						body: JSON.stringify(data),
					})
						.then(resp => {
							return resp.json()
						})
						.then(shipment => {
							//If we have a Message property, it's an error
							if (!shipment || shipment.Message) {
								ractive.set({
									hasShipmentErrorMessage: !shipment || shipment.Message === 'An error has occurred.' ?
										dlsNoResponse : shipment.Message,
									creatingShipment: false,
								})
								return
							}

							ractive.set({
								displayQuotes: false,
								bookedShipment: shipment,
								hasShipmentErrorMessage: false,
								creatingShipment: false,
								creatingShipmentContext: {},
								showShipmentModal: false, // Skip shipment summary close modal
								booked: true
							}).then(() => ractive.displayPdf(shipment.FileBytes, 3))
						})
				})
			},
			displayPdf(base64pdfstring, selectedScale) {
				this.set({ pdf: true }).then(() => {
					const pdfbindata = atob(base64pdfstring)

					pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.487/pdf.worker.min.js'

					pdfjsLib.getDocument({ data: pdfbindata }).then(pdf => {
						// Fetch the first page.
						pdf.getPage(1).then(page => {
							//var scale = scaleValue
							var viewport = page.getViewport(selectedScale)

							// Prepare canvas using PDF page dimensions.
							var canvas = document.getElementById('the-canvas')
							var context = canvas.getContext('2d')
							canvas.height = viewport.height
							canvas.width = viewport.width

							// Render PDF page into canvas context.
							var renderContext = {
								canvasContext: context,
								viewport,
							}
							page.render(renderContext)
						})
					})
				})
			},
			getSourceStoreCache() {
				let sourceStoreCache = localStorage.getItem('sourceAddress')
				return sourceStoreCache ? JSON.parse(sourceStoreCache) : []
			},
			removeCosigneeAccessorial(accessorial) {
				const currentAccessorials = this.get('selectedCosigneeAccessorials')
				const match = currentAccessorials.findIndex(a => a.abbreviation === accessorial.abbreviation)
				this.splice('selectedCosigneeAccessorials', match, 1)
			},
			removeShipperAccessorial(accessorial) {
				const currentAccessorials = this.get('selectedShipperAccessorials')
				const match = currentAccessorials.findIndex(a => a.abbreviation === accessorial.abbreviation)
				this.splice('selectedShipperAccessorials', match, 1)
			},
			setSourceStoreCache(sourceStore) {
				localStorage.setItem('sourceAddress', JSON.stringify(sourceStore))
			},
		},
		querystringParameters: [],
		resolve: (srData, parameters, cb) => {
			const urls = [
				'server/get_commodities.php',
				'server/get_containers.php',
				'server/get_fpg_static.php',
			]

			Promise.all(urls.map(url =>
				fetch(url).then(resp => resp.json()),
			)).then(jsonResponses => {
				const originalSourceStore = { ...sourceStore }

				let sourceStoreCache = localStorage.getItem('sourceAddress')
				sourceStoreCache = sourceStoreCache ? JSON.parse(sourceStoreCache) : []
				const foundStoreCache = sourceStoreCache.find(store => store.storeID === originalSourceStore.storeID)
				let possibleFpgConfigError
				let possibleFpgConfigErrorMessage
				if (jsonResponses[2].error) {
					// set something so that we can display an error
					possibleFpgConfigError = true
					possibleFpgConfigErrorMessage = jsonResponses[2].error
					//return
				}

				const data = {
					excludedProductColumns: [
						{ property: '', name: '' },
						{ property: 'lookup', name: 'Tag Number' },
						{ property: 'storeId', name: 'Store' },
						{ property: 'description', name: 'Description' },
						{ property: 'quantity', name: 'Quantity' },
						{ property: 'price', name: 'Price' },
						{ property: 'total', name: 'Total' },
					],
					bookedShipmentSummaryColumns: [
						{ property: 'service', name: 'Service' },
						{ property: 'containerCount', name: 'Shipping Units' },
						{ property: '', name: 'Additional Weight' },
						{ property: 'weightTotal', name: 'Total Weight' },
						{ property: 'equipment', name: 'Equipment Type' },
						{ property: '', name: 'Special Instructions' },
						{ property: '', name: 'Total Value' },

					],
					fpgBookedSummaryColumns: [
						{ property: 'serviceType', name: 'Service' },
						{ property: 'containerCount', name: 'Shipping Units' },
						{ property: 'Total Weight', name: 'Total Weight' },
						{ property: 'equipmentType', name: 'EquipmentType' },
						{ property: '', name: 'Special Instructions' },
					],
					productColumns: [
						{ property: '', name: '' },
						{ property: 'lookup', name: 'Tag Number' },
						{ property: 'storeId', name: 'Store' },
						{ property: 'description', name: 'Description' },
						{ property: 'quantity', name: 'Qty' },
						{ property: 'price', name: 'Price' },
						{ property: 'total', name: 'Total' },
						{ property: 'dimensions', name: 'Package/Dimensions' },
						{ property: 'classWeight', name: 'Class/Weight' },
					],
					shippingContainerColumns: [
						{ property: 'packageDetails', name: 'Container' },
						{ property: 'products', name: 'Products' },
					],
					quote: [],
					quoteLoading: false,
					showDlsConfirmShipmentModal: false,
					commodities: jsonResponses[0],
					tforceContainers: jsonResponses[1],
					selectedContainer: '',
					// Static FPG options returned from api
					showFpgShipmentModal: false,
					possibleFpgConfigError,
					possibleFpgConfigErrorMessage,
					enableDispatch: false,
					fpgShippingContainers: [],
					fpgEquipmentStatic: possibleFpgConfigError ? [] : jsonResponses[2].equipment, // FPG
					fpgPackageStatic: possibleFpgConfigError ? [] : jsonResponses[2].packages, // FPGk
					fpgPayTypeStatic: possibleFpgConfigError ? [] : jsonResponses[2].paytypes.map(row => row.description), // FPG
					fpgShipTypeStatic: possibleFpgConfigError ? [] : jsonResponses[2].shiptypes.map(row => row.description), // FPG
					fpgServiceStatic: possibleFpgConfigError ? [] : jsonResponses[2].services, // FPG
					fpgAccessorialsStatic: possibleFpgConfigError ? [] : jsonResponses[2].accessorials, // FPG
					postData: camelize(postData),
					salesOrder,
					originalSourceStore,
					sourceStore: foundStoreCache ? foundStoreCache : ({ ...originalSourceStore }),
					countries,
					tforceAccessorials: ['residential', 'lift', 'limited', 'construction', 'overlength', 'hazardous', 'inside'],
					useInsurance: true,
					rememberSourceAddress: !!foundStoreCache,
					defaultWeightUnit: 'lbs'
				}
				cb(null, data)
			})
		},
		activate: context => {
			const ractive = context.domApi
			ractive.observe('postData.shippingSource', shippingSource => {
				// Hinky way to set a default container
				if (shippingSource === 'FPG') {
					ractive.set('defaultSelectedContainer', 'Pallets')

				}	
			})
			ractive.observe('sourceStore', sourceStore => {
				if(sourceStore.contact) {
					return
				}
				const firstName = ractive.get('postData.contactFirstName') 
				const lastName = ractive.get('postData.contactLastName')
				const sourceStoreName = sourceStore.name
				if (firstName && lastName) {
					const contact = `${firstName} ${lastName}`
					ractive.set('sourceStore.contact', contact)
				} else if (sourceStoreName) {
					ractive.set('sourceStore.contact', sourceStoreName)
				}
			})
			ractive.observe('selectedShipperAccessorials', selectedShipperAccessorials => {
				if (!selectedShipperAccessorials.length) {
					ractive.set('emptyShipperAccessorialText', 'None Selected')
				} else {
					ractive.set('emptyShipperAccessorialText', '')
				}
			})
			ractive.observe('selectedCosigneeAccessorials', selectedCosigneeAccessorials => {
				if (!selectedCosigneeAccessorials.length) {
					ractive.set('emptyCosigneeAccessorialText', 'None Selected')
				} else {
					ractive.set('emptyCosigneeAccessorialText', '')
				}
			})
			// Make sure delivery date never gets set earlier than pickup
			ractive.observe('pickupDate', pickupDate => {
				let pickupValue = ractive.get('pickupDate')
				let deliverValue = ractive.get('deliverDate')
				if (typeof pickupValue === 'string') {
					pickupValue = parse(pickupValue, 'MM-dd-yyyy', new Date())
				}
				if (typeof deliverValue === 'string') {
					deliverValue = parse(deliverValue, 'MM-dd-yyyy', new Date())
				}
				if (dateDiff(deliverValue, pickupValue) <= 1) { //Don't override the initial 2 day default
					const oneBusinessDay = addBusinessDays(pickupValue, 1)
					ractive.set('deliverDate', format(oneBusinessDay, 'MM-dd-yyyy'))
				}
			})
			ractive.observe('hasApiError', v => console.log(v), { init: false })

			ractive.observe('sourceStore', () => {
				if (ractive.get('rememberSourceAddress')) {
					ractive.setSourceStoreCache(replaceObjectOrConcat({
						array: ractive.getSourceStoreCache(),
						compareKey: 'storeID',
						object: ractive.get('sourceStore'),
					}))
				}
			}, { init: false })
			ractive.observe('rememberSourceAddress', rememberSourceAddress => {
				if (rememberSourceAddress) {
					ractive.setSourceStoreCache(replaceObjectOrConcat({
						array: ractive.getSourceStoreCache(),
						compareKey: 'storeID',
						object: ractive.get('sourceStore'),
					}))
				} else {
					const sourceStore = ractive.get('sourceStore')
					const sourceStoreCache = ractive.getSourceStoreCache()
						.filter(store => {
							return store.storeID !== sourceStore.storeID
						})

					ractive.setSourceStoreCache(sourceStoreCache)
				}
			}, { init: false })

			ractive.set('sourceStore.country', ractive.countryMagic(ractive.get('sourceStore.country')))
			ractive.set('salesOrder.shipCountry', ractive.countryMagic(ractive.get('salesOrder.shipCountry')))

			// TODO: what was this for?
			// const commoditySelect = ractive.find('#commoditySelect')
			// if (commoditySelect) {
			// 	commoditySelect.focus()
			// }

			ractive.observe('useInsurance', useInsurance => {
				if (useInsurance) {
					ractive.set({ insuredValue: ractive.get('totalValue') })
				} else {
					ractive.set({ insuredValue: '0.00' })
				}
			})
			ractive.observe('totalValue', totalValue => {
				const useInsurance = ractive.get('useInsurance')
				if (useInsurance) {
					ractive.set({ insuredValue: ractive.get('totalValue') })
				}
			})
			ractive.observe('showDlsConfirmShipmentModal', showDlsConfirmShipmentModal => {
				if (!showDlsConfirmShipmentModal) {
					ractive.set({
						hasRateErrorMessage: false,
						hasShipmentErrorMessage: false,
					})
				}
			})
			ractive.observe('showFpgShipmentModal', showFpgShipmentModal => {
				if (!showFpgShipmentModal) {
					ractive.set({
						hasRateErrorMessage: false,
						hasShipmentErrorMessage: false,
					})
				}
			})
			ractive.observe('shipContainers.*.containerWeight shipContainers.*.containerLength shipContainers.*.containerWidth shipContainers.*.containerHeight shipContainers.*.selectedContainerCommodity', (val, oldVal, keypath) => {
				/*
					Another hinky workaround:  TForce doesn't seem to support multiple containers.
					FPG accepts multiple containers but they apparently can't be different dimensions.
					So we'll have to calculate the density by the shared container dimensions and individual container weight.
					We'll undoubtedly have to revisit this if there is future support multiple different sized containers.
				*/
				const integration = ractive.get('setIntegration')
				// Find any with container chosen
				if (integration === 'TForce') {
					const splitKeypath = keypath.split('.')
					const containerKeypath = splitKeypath.slice(0, splitKeypath.length - 1).join('.')
					const container = ractive.get(containerKeypath)
					const { containerWeight, containerLength, containerWidth, containerHeight, selectedContainerCommodity } = container
					if (selectedContainerCommodity && selectedContainerCommodity !== 'custom') {
						ractive.set(containerKeypath + '.containerShipClass', selectedContainerCommodity.class )
					}
					if (!selectedContainerCommodity && containerWeight && containerLength && containerWidth && containerHeight) {
						const classcalculation = containerWeight / (containerLength * containerWidth * containerHeight / 1728)
						let shipClass

						// returns the appropriate class
						switch (true) {
							case (classcalculation > 50):
								shipClass = 50
								break
							case (classcalculation > 35):
								shipClass = 55
								break
							case (classcalculation > 30):
								shipClass = 60
								break
							case (classcalculation > 22.5):
								shipClass = 65
								break
							case (classcalculation > 15):
								shipClass = 70
								break
							case (classcalculation > 13.5):
								shipClass = 85
								break
							case (classcalculation > 12):
								shipClass = 85
								break
							case (classcalculation > 10.5):
								shipClass = 100
								break
							case (classcalculation > 9):
								shipClass = 100
								break
							case (classcalculation > 8):
								shipClass = 110
								break
							case (classcalculation > 7):
								shipClass = 125
								break
							case (classcalculation > 6):
								shipClass = 150
								break
							case (classcalculation > 5):
								shipClass = 175
								break
							case (classcalculation > 4):
								shipClass = 200
								break
							case (classcalculation > 3):
								shipClass = 250
								break
							case (classcalculation > 2):
								shipClass = 300
								break
							case (classcalculation > 1):
								shipClass = 400
								break
							case (classcalculation > 0):
								shipClass = 500
						}
						ractive.set(containerKeypath + '.classEstimateMessage', `Suggested class ${shipClass} based on density`)

						ractive.set(containerKeypath + '.containerShipClass', shipClass )
					}
				}
			}, {init: false})
			ractive.observe('shipContainers.*.products.*', (val, oldVal, keypath) => {
				const productRow = ractive.get(keypath)
				console.log('observe: ', productRow)
				const {weight, weightUnit, shippingWidth, shippingLength, shippingHeight, shippingMeasurementUnit} = productRow.inventory
				const {classWeight, dimensions} = productRow
				// const {productLength, productWidth, productHeight} = dimensions
				const {selectedProductCommodityId} = classWeight
				// // If user selects a commodity and it's not custom, suggest class
				//const updateKeyPath = `shipContainers.${originalContainerIndex}.products.${originalProductIndex}.classWeight.productShipClass`

				if (selectedProductCommodityId) {
					if (selectedProductCommodityId !== 'custom') {
						// class: 300
						// commoditycode: 11111-20
						let productClass = selectedProductCommodityId.class
						// 		// These are not decimals in db
						if (selectedProductCommodityId.class === '92') {
							productClass = '92.5'
						}
						if (selectedProductCommodityId.class === '77') {
							productClass = '77.5'
						}
						console.log("productClass: ", productClass)
						ractive.set(keypath + '.classWeight.productShipClass', productClass)
					}
					// Otherwise, try to calculate a suggested class
				} else if (!selectedProductCommodityId && weight && shippingLength && shippingWidth && shippingHeight) {
					const classCalculation = weight / (shippingLength * shippingWidth * shippingHeight / 1728)
					let shipClass
					// returns the appropriate class
					switch (true) {
						case (classCalculation > 50):
							shipClass = 50
							break
						case (classCalculation > 35):
							shipClass = 55
							break
						case (classCalculation > 30):
							shipClass = 60
							break
						case (classCalculation > 22.5):
							shipClass = 65
							break
						case (classCalculation > 15):
							shipClass = 70
							break
						case (classCalculation > 13.5):
							shipClass = 77.5
							break
						case (classCalculation > 12):
							shipClass = 85
							break
						case (classCalculation > 10.5):
							shipClass = 92.5
							break
						case (classCalculation > 9):
							shipClass = 100
							break
						case (classCalculation > 8):
							shipClass = 110
							break
						case (classCalculation > 7):
							shipClass = 125
							break
						case (classCalculation > 6):
							shipClass = 150
							break
						case (classCalculation > 5):
							shipClass = 175
							break
						case (classCalculation > 4):
							shipClass = 200
							break
						case (classCalculation > 3):
							shipClass = 250
							break
						case (classCalculation > 2):
							shipClass = 300
							break
						case (classCalculation > 1):
							shipClass = 400
							break
						case (classCalculation > 0):
							shipClass = 500
					}
					//const updateKeyPath = `${keypath}.productShipClass`
					//const messageKeypath = `${keypath}.classEstimateMessage`
					ractive.set(keypath + '.classWeight.productShipClass', shipClass)
					ractive.set(keypath + '.classWeight.classEstimateMessage', `Suggested class ${shipClass} based on density`)
				}

			}, { init: false, defer: true})

			ractive.observe('selectedContainer', shipmentContainerId => {
				// TODO: this is a little unfortunate as it doesn't work with separate container
				// dimensions.  However, FPG nor TForce support the concept anyway so leaving
				// this to bite us later.
				const integration = ractive.get('setIntegration')
				// Find any with container chosen
				if (integration === 'TForce' && shipmentContainerId) {
					const { length, width, height } = ractive.get('tforceContainers')
						.find(container => {
							return container.shipmentcontainerid === shipmentContainerId
						})
					// Only set the first container dimensions
					ractive.set('shipContainers.0.containerLength', length)
					ractive.set('shipContainers.0.containerWidth', width)
					ractive.set('shipContainers.0.containerHeight', height)

				}
			}, { init: false })
		},
	})


stateRouter.evaluateCurrentRoute('app')